import React, { useState } from 'react';
import { StyledInputContainer, StyledInput } from './Input.styled';

interface Props {
    width: string | null
    value: string | undefined
    event: (e: any) => void
}
const Input = (props: Props) => {

    return (
        <StyledInputContainer>
            <StyledInput type='text' style={{width: `${props.width}`}} value={props.value} onChange={props.event}/>
        </StyledInputContainer>
    );
}

export default Input;
